import CompleteDropdown from "../../../../shared/Dropdown/CompleteDropdown";
import IconBubble from "../../../../shared/Dropdown/IconBubble";
import { Dropdown } from "react-bootstrap";
import { faCopy, faDisplay, faShare, faTrash, faUserMinus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import crudApi from "@serie3/common/api/crudApi";
import MediaplannerGroupEndpoints from "@serie3/mymediaplanner/Modules/Groups/endpoints";
import ToastMessages from "../../../../../ToastMessages";

/**
 * `editable` = the current user may change this post (author, or group
 * owner/admin). Read-only viewers keep copy and teleprompter; sharing,
 * removing from the group and deleting are the author's calls.
 */
export default function GroupPostMenu({ post, task, group, onEdit, onDelete, onDeletePost, onTeleprompter, onShare, editable = true }) {
  const { t } = useTranslation();

  const copyAction = async () => {
    const shareId = task?.share?.id ?? task?.id;
    if (!group?.id || !shareId) return;
    const response = await crudApi.justGet(
      MediaplannerGroupEndpoints.endpoints.copyPostFromGroup + group.id + "/" + shareId
    );
    if (response.ok) {
      ToastMessages.SuccessfulSave("Post successfully copied");
    } else {
      ToastMessages.Error("Error: Post could not be copied");
    }
  };

  const deletePostAction = async () => {
    if (!group?.id || !task?.id) return;
    const response = await crudApi.del(
      MediaplannerGroupEndpoints.endpoints.deletePost + group.id + "/",
      task.id
    );
    if (response.status === 200) {
      onDeletePost?.(task);
    }
  };

  return (
    <CompleteDropdown>
      <Dropdown.Item onClick={copyAction} className="d-flex align-items-center">
        <IconBubble icon={faCopy} bg="rgba(3,142,220,0.12)" color="#038edc" />
        {t("Backend.Groups.Dropdown.CopyPost")}
      </Dropdown.Item>

      <Dropdown.Item onClick={() => onTeleprompter?.(post)} className="d-flex align-items-center">
        <IconBubble icon={faDisplay} bg="rgba(86,74,177,0.12)" color="#564ab1" />
        {t("Backend.Post.Teleprompter.NavigationTitle")}
      </Dropdown.Item>

      {editable && (
        <Dropdown.Item onClick={() => onShare?.(post)} className="d-flex align-items-center">
          <IconBubble icon={faShare} bg="rgba(247,204,83,0.15)" color="#b8880a" />
          {t("Backend.Post.ShareInGroup")}
        </Dropdown.Item>
      )}

      {editable && <div className="dropdown-divider" />}

      {editable && onDelete && (
        <Dropdown.Item onClick={() => onDelete(task)} className="d-flex align-items-center">
          <IconBubble icon={faUserMinus} bg="rgba(231,76,60,0.12)" color="#e74c3c" />
          <span style={{ color: "#e74c3c" }}>{t("Backend.Groups.Dropdown.RemoveFromGroup")}</span>
        </Dropdown.Item>
      )}

      {editable && (
        <Dropdown.Item onClick={deletePostAction} className="d-flex align-items-center">
          <IconBubble icon={faTrash} bg="rgba(231,76,60,0.12)" color="#e74c3c" />
          <span style={{ color: "#e74c3c" }}>{t("Backend.Groups.Dropdown.DeletePost")}</span>
        </Dropdown.Item>
      )}
    </CompleteDropdown>
  );
}
